import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ApprovalRequest, ApprovalRequestCreate, ApprovalRequestFilter } from '../data/approvalRequest';

export function createApprovalRequestService(client: AxiosInstance) {
  return createCrudService<ApprovalRequest, ApprovalRequestCreate, ApprovalRequestFilter>(
    client,
    '/workflow/ApprovalRequest',
    'id',
  );
}

export type ApprovalRequestService = CrudService<ApprovalRequest, ApprovalRequestCreate, ApprovalRequestFilter>;
